module.exports = __webpack_public_path__ + "media/entities/1803-a90bd737.png";